var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#dcecf2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#063f4f",
    d: "M17 18h12l4 5h14a5 5 0 0 1 5 5v18a5 5 0 0 1-5 5H17a5 5 0 0 1-5-5V23a5 5 0 0 1 5-5Zm0 7v21h30V28H30l-4-5h-9v2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#008db5",
    d: "M23 32h18v4H23zm0 8h13v4H23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryGeneric);
export default __webpack_public_path__ + "static/media/category-generic.2f71afb050468b607d56a1158e570e4e.svg";
export { ForwardRef as ReactComponent };